// Temple Assets Configuration
// Replace these paths with your actual logo and image paths
// Place images in the client/public/images/ folder

export const templeAssets = {
  // Logo - Place your logo at: client/public/images/logo.png
  logo: '/images/logo.png',

  // Alternative logo for footer
  logoFooter: '/images/logo.png',

  // Homepage Hero Image - Place at: client/public/images/hero-image.jpg
  heroImage: '',

  // Temple Images for Gallery/Homepage
  templeImages: {
    main: '',
    gopuram: '',
    deity: '',
    festival: '',
  },

  // Banner Images for Homepage Carousel - Add your images here
  // Place images in client/public/images/ folder
  bannerImages: [],

  // Social Media Links
  socialMedia: {
    facebook: 'https://facebook.com/your-temple',
    instagram: 'https://www.instagram.com/sri_renuka_ankamma_talli?igsh=MXNpdzhrYm02Z2hneg==',
    youtube: 'https://www.youtube.com/@SriRenukaAnkammaTalliOfficial',
  },

  // Contact Information
  contact: {
    address: 'SRI RENUKA ANKAMMA THALLI DEVASTHANAM, LINGAPURAM (VILLAGE),AMARAVATHI (MANDAL),PALNADU (DISTRICT)',
    phone: '+91 9121287233',
    email: 'srirenukaankammatallidevasthan@gmail.com',
  },

  // Temple Name
  templeName: 'SRI RENUKA ANKAMMA TALLI DEVASTHANAM',
  templeNameShort: 'SRATD',

  // Logo Text Configuration (for circular logo)
  logoText: {
    top: 'SRI RENUKA ANKAMMA TALLI DEVASTHANAM', // Top curved text
    bottom: 'LINGAPURAM', // Bottom curved text
  },
};

